import React from "react";
import { useTranslation } from "react-i18next";
import subjectsData from "../../i18n/general_tutoring_subjects.json"; // Import the subjects JSON

const SubjectSelector = ({ selectedSubjects, setSelectedSubjects }) => {
  const { t } = useTranslation();

  // Extract subjects and their subcategories from the JSON data
  const subjects = subjectsData.subjects.map((subject) => ({
    value: subject.value,
    display: subject.display[t("language")], // Use current language from i18n
    subcategories: subject.subcategories.map((subcategory) => ({
      value: subcategory.value,
      display: subcategory.display[t("language")], // Localized display
    })),
  }));

  const handleToggle = (subcategoryValue) => {
    setSelectedSubjects((prev) =>
      prev.includes(subcategoryValue)
        ? prev.filter((r) => r !== subcategoryValue)
        : [...prev, subcategoryValue]
    );
  };

  return (
    <div>
      <label>{t("ad.subject")}</label>

      <div className="">
        {subjects.map((subject) => (
          <div key={subject.value} className="flex">
            <div className="mt-3  ml-1 p-1  ">{subject.display}</div>
            <div className="flex flex-wrap mt-1">
              {subject.subcategories.map((subcategory) => (
                <span
                  key={subcategory.value}
                  onClick={() => handleToggle(subcategory.value)}
                  className={`Select-tag  ${
                    selectedSubjects.includes(subcategory.value)
                      ? "bg-blue-500 text-white"
                      : "bg-gray-200 text-gray-800"
                  }`}
                >
                  {subcategory.display}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SubjectSelector;
